import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import PropTypes from "prop-types";
import CustomPropTypes from "../utils/customPropTypes";
import ImageBlock from "../components/ImageBlock";
import style from "../../scss/components/GenericCarousel";
import AllProducts from "../../scss/components/Products/AllProducts";
import SafeHTML from "../components/SafeHTML";
import ProductCard from "../components/Products/ProductCard";
export default class GenericCarousel extends Component {
  static ControlTypes = {
    Default: "",
    Accessories: "accessories"
  };
  static defaultProps = {
    controlType: GenericCarousel.ControlTypes.Default
  };
  static propTypes = {
    eyebrow: PropTypes.string,
    description: PropTypes.string,
    cards: PropTypes.arrayOf(
      PropTypes.shape({
        eyebrow: PropTypes.string,
        link: CustomPropTypes.Link,
        icon: CustomPropTypes.Image,
        title: PropTypes.string
      })
    ),
    controlType: PropTypes.string
  };
  constructor(props) {
    super(props);
    this.state = { isLastSlide: false, isFirstSlide: true };
  }
  getGenericCardList = () => {
    let items = this.props.cards;
    let self = this;
    if (items && items.length > 0) {
      return items.map(function(objItem, index) {
        return (
          <div key={index} className="post-carousel-item">
            {self.props.controlType ==
              GenericCarousel.ControlTypes.Accessories && (
              <ProductCard product={objItem}></ProductCard>
            )}
            {self.props.controlType == GenericCarousel.ControlTypes.Default && (
              <a
                href={
                  objItem.link.url
                    ? objItem.link.url
                    : objItem.link.document
                    ? objItem.link.document.url
                    : "#"
                }
                target={objItem.link.openInNewWindow ? "_blank" : ""}
                className="post-card"
              >
                <div className="post-card-inner">
                  <div className="post-card-head">
                    <h6 className="post-cat">{objItem.eyebrow}</h6>
                    <ImageBlock
                      image={objItem.icon ? objItem.icon : objItem.image}
                      addWrapper={false}
                    />
                  </div>
                  <h3 className="post-card-title">{objItem.title}</h3>
                  <div className="post-card-action">
                    <i className="icon icon-direction-right"></i>
                  </div>
                </div>
              </a>
            )}
          </div>
        );
      });
    } else return null;
  };
  nextSlide() {
    this.refs.slider.slickNext();
  }
  prevSlide() {
    this.refs.slider.slickPrev();
  }
  setStateForActiveSlides = (currentIndex, slideToShow) => {
    this.setState({
      isFirstSlide: currentIndex == 0,
      isLastSlide: currentIndex == this.props.cards.length - slideToShow
    });
  };
  isAccessoryCtrl = () => {
    return this.props.controlType == GenericCarousel.ControlTypes.Accessories;
  };
  getSliderSettings = () => {
    var self = this;
    var slideToShow = self.isAccessoryCtrl() ? 4 : 3;
    return {
      className: "post-carousel-items",
      slidesToShow: slideToShow,
      slidesToScroll: 1,
      swipeToSlide: true,
      infinite: false,
      dots: false,
      afterChange: function(index) {
        self.setStateForActiveSlides(index, slideToShow);
      },
      arrows: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: true,
            afterChange: function(index) {
              self.setStateForActiveSlides(index, 2);
            }
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            afterChange: function(index) {
              self.setStateForActiveSlides(index, 1);
            }
          }
        }
      ]
    };
  };
  getSliderButtons = () => {
		var slideToShow = this.isAccessoryCtrl() ? 4 : 3;
    if (this.props.cards && this.props.cards.length > slideToShow) {
      return (
        <>
          <a
            onClick={() => {
              this.prevSlide();
            }}
            className={
              "btn btn-circle" + (this.state.isFirstSlide ? " disabled" : "")
            }
          >
            <i className="icon icon-prev"></i>
          </a>
          <a
            onClick={() => {
              this.nextSlide();
            }}
            className={
              "btn btn-circle" + (this.state.isLastSlide ? " disabled" : "")
            }
          >
            <i className="icon icon-next"></i>
          </a>
        </>
      );
    } else return null;
  };
  render() {
    return (
      <div className={"post-carousel-section " + this.props.controlType}>
        <div className="container">
          <div className="post-carousel border-none-mobile">
            <div className="post-carousel-head">
              <div className="post-info">
                {!this.isAccessoryCtrl() && this.props.eyebrow && (
                  <h1 className="hunterlab-title post-info-title">
                    {this.props.eyebrow}
                  </h1>
                )}
                <div className="post-info-desc">
                  <SafeHTML>
                    {this.isAccessoryCtrl()
                      ? this.props.eyebrow
                      : this.props.description}
                  </SafeHTML>
                </div>
              </div>
              <div className="post-info-action">{this.getSliderButtons()}</div>
            </div>
            <Slider ref="slider" {...this.getSliderSettings()}>
              {this.getGenericCardList()}
            </Slider>
          </div>
        </div>
      </div>
    );
  }
}
